import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_unban.component.html'
})
export class SetUnBanModalComponent extends BaseSupportModalComponent {
	userId: string;
	email: string;

	async ok() {
		await this.supportService.setUnBan(this.userId, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
